import React, { useEffect, useState } from "react";

type Props = {
    curAccount: any;
    setCertificate: any;
    showAccount: number;
    name: any;
    setName: any;
    editable: boolean;
    setIsSavedResult: any,

};

export const AssessmentYearRow = ({
                                      curAccount,
                                      setCertificate,
                                      showAccount,
                                      name,
                                      setName,
                                      editable,
                                      setIsSavedResult
                                  }: Props) => {
    const [localTaxYear, setLocalTaxYear] = useState<string>(
        curAccount?.assessment?.taxYear?.toString() || ""
    );

    useEffect(() => {
        setLocalTaxYear(curAccount?.assessment?.taxYear?.toString() || "");
    }, [curAccount?.assessment?.taxYear]);

    const validateAssessmentYear = (inputValue: string): string => {
        const numericOnly = inputValue.replace(/\D/g, "");
        return numericOnly.slice(0, 4);
    };

    return (
        <input
            className="text-surface-3 pl-2 pr-2 rounded w-20 bg-surface-5"
            name="taxYear"
            id="taxYear"
            type="text"
            autoComplete="off"
            placeholder="Select Year..."
            value={localTaxYear}
            onChange={(e) => {
                const validated = validateAssessmentYear(e.target.value);
                setLocalTaxYear(validated);
                setIsSavedResult(false)

            }}
            onBlur={() => {
                const parsedYear = localTaxYear ? parseInt(localTaxYear) : "";

                setCertificate((prev: any) => {
                    const updatedAccounts = [...prev.accounts];
                    const updatedAccount = {
                        ...updatedAccounts[showAccount],
                        assessment: {
                            ...updatedAccounts[showAccount].assessment,
                            taxYear: parsedYear,
                        },
                        taxDataSource: 'EDITOR',
                        asOfDate: new Date(),

                };
                    updatedAccounts[showAccount] = updatedAccount;

                    return {
                        ...prev,
                        accounts: updatedAccounts,
                    };
                });

                setName(name);
            }}
            readOnly={!editable}
        />
    );
};
